import React, { Component } from 'react';
import "bootstrap/dist/css/bootstrap.css"
import "../css/font-awesome.min.css"
import "../css/style.css"
import "../css/responsive.css"
import logo from "../images/logo.png"
import menuToggle from "../images/orange-toggle.svg"
import $ from "jquery"
import { Link } from "react-router-dom";
// import { getData } from '../services';

export default class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userId: ""

    }
    this.logout = this.logout.bind(this);
    this.redirectToStories = this.redirectToStories.bind(this);
  }
  async redirectToStories(val) {
    window.location.href = "/insightss/id=" + val
  }
  logout() {
    localStorage.removeItem("userId");
    localStorage.removeItem("userName");
    localStorage.removeItem("userImage")
    localStorage.removeItem("guidanceArray");
    window.location.href = "/"
  }
  componentDidMount() {
    let userId = localStorage.getItem("userId")
    this.setState({
      userId: userId
    })
    $(".content-right-wrapper").click(function () {
      $(".menu-wrapper").removeClass("menu-wrapper-active");
    });


    //   // setInterval(()=>{
    //   //   this.getLoginInfocommon()
    //   // },25000)

    //   if (window.sessionStorage.getItem("userId") === "" || window.sessionStorage.getItem("userId") === null || window.sessionStorage.getItem("userId") === "null") {
    //     //this.props.history.push('/');
    //     window.location.href="/"
    //   }
    //   const url = new URL(window.location); 
    //   //url.searchParams.set('', '');
    //   //alert()
    //   window.history.pushState({}, '', url);
  }
  menuShow() {
    $(".header-wrapper").toggleClass("menu-wrapper-mobshow")
  }
  menuHide() {
    $(".header-wrapper").removeClass("menu-wrapper-mobshow")
  }

  // logOut() {
  //   window.sessionStorage.clear();
  //   window.location.href = "/"

  // }
  // getLoginInfocommon() {    

  //     const postData = {
  //       "functionName": "loginAuth",
  //       "route": "user",
  //       "token": window.sessionStorage.getItem('token')
  //     }
  //     //console.log('login token....',token)  
  //     getData(postData).then((data) => {    
  //       //console.log('login data....',data)   
  //       if (data.data.response[0].success === "1") {

  //       }
  //       else {
  //         this.logOut()
  //       }
  //     })

  // }
  render() {
    // var roleId = window.sessionStorage.getItem('roleId')
    let url = ""
    // if (roleId === "3") {
    //   url = "/taluk/dashboard"
    // }
    // else if (roleId === "2") {
    //   url = "/doctorDashboard"
    // }
    // else if (roleId === "4") {
    //   url = "/district/dashboard"
    // }
    // else if (roleId === "7") {
    //   url = "/insurance/dashboard"
    // }
    // else if (roleId === "5") {
    //   url = "/state/dashboard"
    // }
    let institutionLoginName = window.sessionStorage.getItem('institutionLoginName')
    var userId = localStorage.getItem("userId")
    console.log("user.........", userId)
    return (

      <div className="header-wrapper" id="top">
        <div className="container">
          <nav className="navbar navbar-expand-lg">
            <button className="navbar-menushow" onClick={() => this.menuShow()}>
              <img src={menuToggle}></img>
            </button>

            <Link className="navbar-brand logo p-0" to={url}>
              <img src={logo}></img>
            </Link>
            {/* <button className="LogutBtnHeader" onClick={() => this.logOut()}>Logout</button> */}

            <div className='menu-wrapper'>
              <div className='menuList menuListClose'>
                <Link className='menuListLink'>Menu </Link>
                <button className="navbar-close" type="button" onClick={() => this.menuHide()}>
                  <svg width="16" height="17" viewBox="0 0 16 17" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.142135 2.00015L1.55635 0.585938L15.6985 14.7281L14.2843 16.1423L0.142135 2.00015Z" fill="currentColor"></path>
                    <path d="M14.1421 1.0001L15.5563 2.41431L1.41421 16.5564L0 15.1422L14.1421 1.0001Z" fill="currentColor"></path>
                  </svg>
                </button>
              </div>
              {/* <div className='menuList'>
                <Link className='menuListLink' to="/courses">Master Class</Link>
              </div> */}
              {/* <div className='menuList'>
                <Link className='menuListLink' to="/careerTracks">Career Tracks</Link>
              </div> */}
              {/* <div className='menuList'>
                <Link className='menuListLink' to="/experts">Experts</Link>
              </div> */}
              <div className='menuList menuListHover'>
                <Link className='menuListLink'>Resources</Link>
                <div className='menuListSub'>
                  <div className='menuList'>
                    <Link className='menuListLink' onClick={() => this.redirectToStories("Course Reviews")}>Course Reviews</Link>
                  </div>
                  <div className='menuList'>
                    <Link className='menuListLink' onClick={() => this.redirectToStories("Stories")}>Stories</Link>
                  </div>
                  <div className='menuList'>
                    <Link className='menuListLink' onClick={() => this.redirectToStories("Blogs")}>Blogs</Link>
                  </div>
                </div>
              </div>
              {!userId &&
                <div className='menuList'>
                  <Link className='menuListLink' to="/assesment/apply">Get Started</Link>
                </div>
              }
              {/* <div className='menuList'>
                <Link className='menuListLink' to="/profile">Profile</Link>
              </div> */}
              <div className='menuList'>
                {userId ?
                  <Link className='menuListLink' to={"/user-dashboard"}>
                    Dashboard
                    </Link>
                  :
                  ""
                }
              </div>
              <div className='menuList'>
                {userId ?
                  <Link className='btn-theme' onClick={this.logout}>Logout</Link>
                  :
                  <Link className='btn-theme' to="/my-account">Login</Link>
                }
              </div>
            </div>
          </nav>
        </div>

      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/layout/header.jsx